import { render, staticRenderFns } from "./transformationTable.vue?vue&type=template&id=45bb3351&scoped=true&"
import script from "./transformationTable.vue?vue&type=script&lang=js&"
export * from "./transformationTable.vue?vue&type=script&lang=js&"
import style0 from "./transformationTable.vue?vue&type=style&index=0&id=45bb3351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb3351",
  null
  
)

export default component.exports